import { CMWorkflowStatus, CMRequestReason, type SkuCpiiMapping } from '../../../../models/CatalogManagement';
import type { CpGpMatchedProduct } from '../../../../models/Coupang';
import type { CreateCMWorkflowRequest } from '../../../../infrastructure/CMWorkflowClient';

export type Step1CompletionPlan =
  | { kind: 'blocked'; message: string }
  | { kind: 'submit'; payload: CreateCMWorkflowRequest };

// Decides whether completing step 1 (Product Info Generate) should fire a CM workflow upsert.
// Intentionally takes NO existing-workflow input: POST /cmWorkflow upserts by gpi+cppi, so a
// product with a pre-existing (e.g. legacy COMPLETED) workflow must still submit — gating on
// cmWorkflowData here was what made the button a silent no-op for legacy matches.
export function planStep1Completion(
  matchedProduct: CpGpMatchedProduct,
  selectedWave: string,
  operator: string,
): Step1CompletionPlan {
  if (!selectedWave) {
    return { kind: 'blocked', message: 'Please select a Wave first before completing this step!' };
  }

  const scAgentEngData = matchedProduct.gpDetailedProduct?.scAgentEngData;
  if (!scAgentEngData) {
    return {
      kind: 'blocked',
      message: 'Please fetch and save the translation data (scAgentEngData) before completing this step!',
    };
  }

  const savedProducts = matchedProduct.ssRestructuredProducts || [];
  const skuCpiiMappings: SkuCpiiMapping[] = savedProducts
    .filter((product) => product.cpItemId && product.sku)
    .map((product) => ({
      sku: product.sku as string,
      cpii: product.cpItemId as string,
      type: product.type,
    }));

  const payload: CreateCMWorkflowRequest = {
    gpi: matchedProduct.gpProductId,
    cppi: matchedProduct.cpProductId,
    ...(skuCpiiMappings.length > 0 && { skuCpiiMappings }),
    cmStatus: CMWorkflowStatus.PRODUCT_INFO_GENERATED,
    wave: selectedWave,
    cmOperation: {
      operator,
      reason: CMRequestReason.NEW_MATCH,
      message: '',
    },
  };

  return { kind: 'submit', payload };
}
